const CodeTalkContainer = () => import(/* webpackChunkName: 'codelist' */ 'wap/views/code-talk/App.vue')
const SearchCode = () => import(/* webpackChunkName: 'codelist' */ 'wap/views/code-talk/routes/SearchCode')
const Bookingcode = () => import(/* webpackChunkName: 'codelist' */ 'wap/views/code-talk/routes/Bookingcode')
const Talkboard = () => import(/* webpackChunkName: 'codelist' */ 'wap/views/code-talk/routes/Talkboard')
const LoadCode = () => import(/* webpackChunkName: 'codelist' */ 'wap/views/code-talk/routes/LoadCode')

const routes = [
  {
    path: '/codelist/search',
    name: 'searchCode',
    component: SearchCode,
    meta: {
      enableTheme: true
    }
  },
  {
    path: '/codelist',
    component: CodeTalkContainer,
    redirect: '/codelist/bookingcode',
    children: [
      {
        path: 'talkboard',
        name: 'talkboard',
        component: Talkboard,
        meta: {
          title: 'Betting Chat Room | MSport'
        }
      },
      {
        path: '/load_code',
        alias: ['load_code'],
        name: 'loadCode',
        component: LoadCode,
        meta: {
          title: 'Load Booking Code | MSport',
          enableTheme: true
        }
      },
      {
        path: 'bookingcode',
        name: 'bookingcode',
        component: Bookingcode,
        meta: {
          title: 'Football Predictions & Booking Codes Today | MSport',
          enableTheme: true
        },
        props: (route) => {
          let { oddslot, oddsInput, market } = route.query
          const { period, sportId, marketId } = route.query

          if (oddslot) oddslot = oddslot.indexOf(',') !== -1 ? JSON.parse(oddslot) : decodeURIComponent(oddslot).split(',')
          if (oddsInput) oddsInput = oddsInput.indexOf(',') !== -1 ? JSON.parse(oddsInput) : decodeURIComponent(oddsInput).split(',')
          if (sportId && marketId) {
            market = { sportId, marketId }
          } else if (market) {
            market = JSON.parse(market)
          }

          return {
            oddslot: oddslot || null,
            oddsInput: oddsInput || null,
            period: period && decodeURIComponent(period),
            market: market || null
          }
        }
      }
    ]
  },
  {
    path: '/codelist',
    redirect: '/codelist/bookingcode'
  }
]

export default routes
